
define('modules/application/wizard/steps/configurationOverview',[
  "app",

  // Libs
  "backbone",
  "jqueryUi",

  //Class
  "./regularStep"
],

function(app, Backbone, jQueryUi, RegularStep) {

  //Creating an event aggragatop
  var configurationOverviewEventAggregator    = _.extend({}, Backbone.Events);


  //Extending regularStep views
  var configurationOverviewViews           = _.extend({},RegularStep.Views);
  _.extend(configurationOverviewViews, {

    Content  : RegularStep.Views.Content.extend({
      template     : "application/wizard/steps/configuration-overview",
      events : {
        'click #clipboardJSonSend'   : 'clipboardJSonSendEventHanlder',
        'click #clipboardJSonReceive': 'clipboardJSonReceiveEventHanlder'
      },

      serialize    : function() {return {model : BticinoS4B.Instances.Models.ApplicationModel.get("completeConfiguration"), app : BticinoS4B.Instances.Models.ApplicationModel};},
      initialize   : function() {

        //Binding events
        this.model.get("stepEventAggregator").unbind("recalculation:request",this.recalculate);
        this.model.get("stepEventAggregator").bind("recalculation:request",this.recalculate, this);

        this.loader               = new window.BticinoS4B.Instances.Views.LoaderView({
          model       :  {
            quote       : "IDS_W1_9095",
            closeButton : false
          }
        });
        this.insertView(".popups", this.loader);
      },

      showDebugPrompt: function(text){
        window.prompt("Copy to clipboard: Ctrl+C, Enter", text);
      },

      clipboardJSonSendEventHanlder: function(){
        var text = BticinoS4B.Instances.Models.ApplicationModel.get("lastModelSentToConfigurationService");
        var res = BticinoS4B.jsbeautifier.js_beautify(text);
        this.showDebugPrompt(res);
      },

      clipboardJSonReceiveEventHanlder: function(){
        var text = BticinoS4B.Instances.Models.ApplicationModel.get("lastConfiguration");
        var res = BticinoS4B.jsbeautifier.js_beautify(text);
        this.showDebugPrompt(res);
      },

      recalculate                                     : function() {
        this.loader.show(this.requestRecalculation, this.render, this);
      },

      requestRecalculation                            : function() {
        BticinoS4B.Instances.Models.ApplicationModel.startAutomaticCalculation();
        this.recalculationCompletedEventHandler();
      },

      recalculationCompletedEventHandler              : function() {
        this.loader.hide();
      },

      afterRender  : function() {
        var pageContent     = $(this.el).find(".itemContent");
        var wizardSection   = $('#wizard');

        pageContent.css("height", (wizardSection.height()-44)+"px");

        $(this.el).find("h3 .titleBarcontent span").corner("2px");
        $(this.el).find(".accordionView").accordion({collapsible: true, active: 0, autoHeight: false });
      }
    })

  });

  //Creating a model with a collection of configurationOverview
  var configurationOverviewModel           = Backbone.Model.extend({
    initialize           : function() {
      window.BticinoS4B.eventAggregator.unbind("configurationOverview:requested", this.tabShowEventHandler);
      window.BticinoS4B.eventAggregator.bind("configurationOverview:requested",   this.tabShowEventHandler, this);
    },
    tabShowEventHandler : function()  {
      this.get("stepEventAggregator").trigger("recalculation:request", this);
    },
    requestShow          : function() {
      this.get("products").view.show();
    }
  });

  //Creating final configurationOverview class
  var configurationOverview                = _.extend({}, RegularStep, {
    objClass    : "configurationOverview",
    Views       : configurationOverviewViews,
    Model       : configurationOverviewModel
  });

  // Required, return the module for AMD compliance
  return configurationOverview;

});